// import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const DrAnuradhaTikheYogaContent = () => {
  return (
    <>
      <Header />
      <div style={{ backgroundColor: "#fff9ee", padding: "40px 20px", paddingTop: "120px" }}>
        <div
          className="doctor-intro-container"
          style={{
            maxWidth: "1100px",
            margin: "auto",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: "32px",
            textAlign: "left",
          }}
        >
          <img
            src="/Doctorprofile.png"
            alt="Dr. Anuradha Tikhe"
            style={{
              width: "220px",
              height: "220px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "3px solid #ddd",
              flexShrink: 0,
            }}
          />

          <div
            className="vertical-divider"
            style={{
              width: "2px",
              backgroundColor: "#ccc",
              height: "100%",
              minHeight: "160px",
              display: "none",
            }}
          ></div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              flex: 1,
              minWidth: "260px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
              className="content-container"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
                className="inner-content"
              >
                <div style={{ flex: 1 }}>
                  <h2 style={{ fontWeight: "bold", marginBottom: "8px" }}>
                    Dr. Anuradha Tikhe
                  </h2>
                  <p style={{ margin: "4px 0", color: "#333" }}>
                    <strong>Specialization:</strong> Mind-Body Guide & Prenatal Yoga Expert
                  </p>
                  <p style={{ margin: "4px 0", color: "#333" }}>
                    <strong>Experience:</strong> 16+ Years specializing in prenatal and postnatal wellness
                  </p>
                  <p style={{ margin: "4px 0", color: "#333" }}>
                    <strong>Degrees:</strong> BHMS, MPH (Mumbai), Certificate in Prenatal & Postnatal Yoga
                  </p>
                </div>

                <div
                  className="vertical-divider"
                  style={{
                    width: "2px",
                    backgroundColor: "#ccc",
                    height: "100%",
                    minHeight: "160px",
                    display: "none",
                  }}
                ></div>

                <div style={{ flex: 1 }}>
                  <p
                    style={{
                      fontStyle: "italic",
                      fontSize: "15px",
                      lineHeight: "1.6",
                      color: "#444",
                      marginTop: "4px",
                    }}
                  >
                    "Pregnancy is the ultimate practice of mindfulness. Through breath and gentle
                    movement, we build strength, calm the mind, and connect deeply with the life
                    growing within you."
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>
        {`
          @media (min-width: 768px) {
            .vertical-divider {
              display: block !important;
            }
      
            .inner-content {
              flex-direction: row !important;
            }
          }
      
          @media (max-width: 767px) {
            .doctor-intro-container {
              flex-direction: column;
              align-items: center !important;
              text-align: center !important;
            }
      
            .inner-content {
              flex-direction: column !important;
              align-items: center !important;
              text-align: center !important;
            }
      
            .content-container {
              align-items: center !important;
              text-align: center !important;
            }
          }
        `}
      </style>


      <div style={{ padding: "40px 20px", maxWidth: "1100px", margin: "auto" }}>
        <h3>My Philosophy on Prenatal Wellness:</h3>
        <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
          I believe that the journey of pregnancy is an incredible opportunity to build a powerful connection between mind and body. My role isn't just to teach yoga poses; it's to guide you through a practice that reduces anxiety, improves physical comfort, and prepares you emotionally and physically for labour. We focus on safe, gentle movements that create space for your baby, and breathing techniques that will become your anchor during childbirth and beyond.
        </p>

        <h3 style={{ marginTop: "32px" }}>Why I Partnered with Myprega:</h3>
        <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
          Myprega understands that a mother's well-being is holistic. They are the only platform that truly integrates physical fitness and mental peace into the core medical plan. Here, yoga isn't an optional add-on; it's a fundamental part of ensuring a happy, healthy pregnancy, and I am honoured to lead that practice.
        </p>

        <h3 style={{ marginTop: "32px" }}>Beyond the Clinic:</h3>
        <p style={{ marginTop: "12px", lineHeight: "1.6", color: "#444" }}>
          When I'm not teaching, I am an avid student of Ayurveda and love creating herbal teas. I find peace in nature and take long, silent walks to recharge. I believe in living the principles I teach, finding moments of stillness and gratitude in everyday life.
        </p>
      </div>

      <div style={{ backgroundColor: "#f9f7f2", padding: "40px 20px" }}>
        <div
          className="doctor-intro-container"
          style={{
            maxWidth: "1100px",
            margin: "auto",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "24px",
            paddingTop: "32px",
          }}
        >
          {/* Favourite Book */}
          <div style={{ flex: 1, minWidth: "250px" }}>
            <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
              📖 Favourite Book
            </p>
            <p style={{ color: "#333" }}>The Heart of Yoga by T.K.V. Desikachar</p>
          </div>

          {/* Divider */}
          <div
            className="vertical-divider"
            style={{
              width: "1px",
              backgroundColor: "#ccc",
              height: "auto",
              minHeight: "50px",
              alignSelf: "stretch",
              display: "none",
            }}
          ></div>

          {/* Favourite Singer */}
          <div style={{ flex: 1, minWidth: "250px" }}>
            <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
              🎵 Favourite Musician
            </p>
            <p style={{ color: "#333" }}>Deva Premal</p>
          </div>

          {/* Divider */}
          <div
            className="vertical-divider"
            style={{
              width: "1px",
              backgroundColor: "#ccc",
              height: "auto",
              minHeight: "50px",
              alignSelf: "stretch",
              display: "none",
            }}
          ></div>

          {/* Favourite Pastime */}
          <div style={{ flex: 1, minWidth: "250px" }}>
            <p style={{ fontWeight: "bold", marginBottom: "4px" }}>
              🌿 Favourite Pastime
            </p>
            <p style={{ color: "#333" }}>
              Creating herbal teas <br />
              Silent nature walks <br />
              Practicing mindfulness and gratitude
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default DrAnuradhaTikheYogaContent;
